import { useState, useEffect, useRef } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { getColours, getLightColour } from "../Components/Util";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function GraphCell(props) {
  const [size, setSize] = useState(0);
  const [hover, setHover] = useState(false);
  const myDiv = useRef();

  useEffect(
    () => {},
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [size, props, hover]
  );

  const backgroundGradient = {
    id: "backgroundGradient",
    beforeDraw: (chart, args, options) => {
      const { ctx } = chart;
      ctx.save();
      ctx.globalAlpha = 1.0;
      const gradient = ctx.createLinearGradient(0, 0, 0, chart.height);
      gradient.addColorStop(0.0, hover ? getLightColour() : "whitesmoke");
      gradient.addColorStop(1.0, "white");
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, chart.width, chart.height);
      ctx.restore();
    },
  };

  const options = {
    indexAxis: "y",
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: "Electricity Production by Source (GW)",
        color: "black",
        font: {
          size: 20,
          family: "Roboto",
          weight: "normal",
        },
      },
      tooltip: {
        intersect: false,
      },
      DateLabels: false,
    },
    scales: {
      y: {
        grid: {
          display: false,
        },
        ticks: {
          autoSkip: false,
        },
      },
    },
  };

  const labels = [
    "Nuclear",
    "Geothermal",
    "Biomass",
    "Coal",
    "Wind",
    "Solar",
    "Hydro",
    "Gas",
    "Oil",
    "Unknown",
    "Hydro Storage",
    "Battery Storage",
  ];

  const data = {
    labels,
    datasets: [
      {
        label: "GW",
        data: [
          props.sourceNuclear / 1000,
          props.sourceGeothermal / 1000,
          props.sourceBiomass / 1000,
          props.sourceCoal / 1000,
          props.sourceWind / 1000,
          props.sourceSolar / 1000,
          props.sourceHydro / 1000,
          props.sourceGas / 1000,
          props.sourceOil / 1000,
          props.sourceUnknown / 1000,
          props.sourceHydroDischarge / 1000,
          props.sourceBatteryDischarge / 1000,
        ],
        backgroundColor: getColours(),
        borderColor: getColours(),
        borderWidth: 1,
      },
    ],
  };

  new ResizeObserver((div) => {
    if (myDiv !== undefined && myDiv != null) {
      if (myDiv.current !== undefined && myDiv.current != null) {
        if (
          myDiv.current.clientWidth !== undefined &&
          myDiv.current.clientWidth != null
        ) {
          let newSize = Math.min(
            myDiv.current.clientWidth,
            myDiv.current.clientHeight * 1.2
          );
          if (newSize !== size) {
            setSize(newSize);
          }
        }
      }
    }
  }).observe(document.querySelector("div"));

  return (
    <div
      className={"cell"}
      ref={myDiv}
      onClick={props.onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <Bar
        options={options}
        data={data}
        plugins={[backgroundGradient]}
        redraw={true}
      />
    </div>
  );
}
